export const ADD_API_ERROR = 'ADD_API_ERROR';
export const REMOVE_API_ERROR = 'REMOVE_API_ERROR';
